import { useTranslation } from '@chr/online-shared-ui-localizations';
import { Icon, Tooltip } from '@mui/material';
import { DisplayEtaSource } from '@/common/constants/booking-types';

export const etaSourcesInfo: Partial<Record<DisplayEtaSource, { icon: string; description: string }>> =
  {
    [DisplayEtaSource.ChrGlobalForwarding]: {
      icon: 'public',
      description: 'Calculated by the dedicated CHR Global Forwarding team.',
    },
    [DisplayEtaSource.DataScience]: {
      icon: 'science',
      description: 'Calculated using our Data Science pipeline using the latest information.',
    },
  };

export interface EtaDataSourceProps {
  displayEtaSource?: string;
}

const EtaDataSource = ({ displayEtaSource }: EtaDataSourceProps) => {
  const translate = useTranslation();
  const etaSourceInfo = etaSourcesInfo[displayEtaSource as DisplayEtaSource];

  if (!etaSourceInfo) {
    return null;
  }

  return (
    <Tooltip title={translate(etaSourceInfo.description)} placement="top">
      <Icon color="primary" tabIndex={0} aria-hidden="false" sx={{ marginRight: 0.5 }} data-testid="etaDataSourceInfo">
        {etaSourceInfo.icon}
      </Icon>
    </Tooltip>
  );
};

export default EtaDataSource;
